<template>
  <a
    :href="nbbUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center space-x-2 py-2 duration-200"
  >
    <img
      :src="faviconUrl"
      alt="Banque Nationale favicon"
      class="w-6 h-6 rounded mr-8"
      @error="fallbackFavicon"
    />
    <span class="text-black-600 text-sm hover:text-blue-800 transition-transform duration-200 hover:scale-105 flex items-center">
      {{ $gettext("Page Banque Nationale") }}
    </span>
  </a>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  enterpriseNumber: { type: String, required: true }
})

const cleanedEnterpriseNumber = computed(() =>
  props.enterpriseNumber.replace(/\D/g, '')
)

const nbbUrl = computed(() =>
  `https://consult.cbso.nbb.be/consult-enterprise/${cleanedEnterpriseNumber.value}`
)

const faviconUrl = ref('https://www.nbb.be/favicon.ico')

function fallbackFavicon(event) {
  event.target.src = 'https://www.google.com/s2/favicons?domain=www.nbb.be'
}
</script>
